export default function () {
  controller('header', self => {
   const menuTrigger = self.find('.js-header-menu');
   const menu = self.find('.header__nav');
   
   menuTrigger.on('click', e =>{
     e.preventDefault();
     let self = $(e.currentTarget);
     
     self.toggleClass('active tcon-transform');
     menu.toggleClass('show');
   });
  });
}
